import { Turnstile } from '@marsidev/react-turnstile'

export default function Widget() {
  return <Turnstile siteKey='0x4AAAAAAALv_FoMsQjDps6f' />
}
